import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentTemplate, Progress, TitleHeader } from 'web-library';
import { AUTHORITY_NAMES } from 'web-library/models/AuthorityFunctions';
import { useHistory } from 'react-router-dom';
import OopAdminResitRegistration from '../../../modules/resit/components/@opadmin/OopAdminResitRegistration';
import { useGetUserAuthorities } from '../../../api-refactored/user/useGetUserAuthorities';
import RouteKey from '../../../routes/key';

const { error } = RouteKey.child;
const { generic } = RouteKey.error.child;

const OpAdminResitApply = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [hasView, setHasView] = useState<boolean>(false);

  const { data: authorities, isLoading: isLoadingAuthorities } = useGetUserAuthorities();

  useEffect(() => {
    if (!authorities?.includes(AUTHORITY_NAMES.CP_ADMIN_GRANT_RESIT_UNIQUE_LINK_VIEW)) {
      history.push(`/${error}/${generic}`);
    } else {
      setHasView(true);
    }
  }, [history, authorities]);

  return (
    <>
      <TitleHeader title={t('resit->>OpAdminResit.Resit')} />
      {!isLoadingAuthorities && hasView ? (
        <OopAdminResitRegistration />
      ) : (
        <ContentTemplate>
          <Progress size="XL" color="secondary" />
        </ContentTemplate>
      )}
    </>
  );
};
export default OpAdminResitApply;
